import React, { useState, useEffect } from "react";
// URLパラメータ管理 React Router実装
import { useSearchParams } from "react-router-dom";  // ← これが必須
import "./App.css";
import { useRef } from "react";


function App() {
    // 正しい順序 searchParamsを定義してからsetQueryを呼ぶ
    const [searchParams, setSearchParams] = useSearchParams();

    //* CHDIRでディレクトリ移動PT6相当実装 20251230
    // const [query, setQuery] = useState("");
    //* const [query, setQuery] = useState(searchParams.get("query") || "");
    //* const [folder, setFolder] = useState("PT3");
    const initialQuery = searchParams.get("q") || "";
    const initialFolder = searchParams.get("d") || "PT3";

    const [query, setQuery] = useState(initialQuery);
    const [folder, setFolder] = useState(initialFolder);

    const [files, setFiles] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [selectedMediaFile, setSelectedMediaFile] = useState(null);
    const [mediaType, setMediaType] = useState(null);
    // const [server, setServer] = useState("pi42");
    const [server, setServer] = useState("fedora42");
    const [recentWords, setRecentWords] = useState([]); // 20251215
    const perPage = 100;
    // 差分diffモード対応 20260102
    // const [useDiff, setUseDiff] = useState(false);
    const [useDiff, setUseDiff] = useState(true);
    // 差分diffモードのときのサムネ画像チカチカ対応
    const [thumbFailed, setThumbFailed] = useState({});
    // 直近N日以内フィルタ 20260112
    // const [recentOnly, setRecentOnly] = useState(true); // ← デフォルトON
    const [recentOnly, setRecentOnly] = useState(false); // ← デフォルトOFF
    const [recentDays, setRecentDays] = useState(3);   // 3日 / 7日 切替用

    // JPG表示選択checkbox 20260223
    const [showJpg, setShowJpg] = useState(false);

    // 直近N日以内フィルタ 20260112 表示用フィルタ関数を追加
    const filterRecentVideos = (files) => {
        if (!recentOnly) return files;
        const now = Date.now() / 1000;
        const limit = recentDays * 24 * 60 * 60;
        return files.filter(f => {
            if (!f.mtime || !f.name) return false;
            const ext = f.name.split(".").pop().toLowerCase();
            if (!["mp4","mov","mkv","ts","webm","m4v","f4v"].includes(ext)) {
                return false;
            }
            return (now - f.mtime) <= limit;
        });
    };

    // 一覧タイトルクリックでクリップボードにコピーCOPY実装 20251228
    const copyToClipboard = async (text) => {
        // --- 新Clipboard API (HTTPS限定) ---
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(text);
                showToast(`コピーしました`);
                return;
            } catch (e) {
                console.warn("Clipboard API failed, fallback", e);
            }
        }

        // --- fallback (HTTPでも動く) ---
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);

            showToast(`コピーしました`);
        } catch (e) {
            console.error("fallback copy failed", e);
            showToast("コピーに失敗しました");
        }
    };
    const clickTimer = useRef(null);
    const handleTitleClick = (file) => {
        if (clickTimer.current) return;
        clickTimer.current = setTimeout(() => {
            // ★ シングルクリック → 再生
            handleThumbClick(file);
            clickTimer.current = null;
        }, 250); // ダブルクリック判定猶予
    };

    const handleTitleDoubleClick = (file) => {
        if (clickTimer.current) {
            clearTimeout(clickTimer.current);
            clickTimer.current = null;
        }
        // ★ ダブルクリック → コピー
        copyToClipboard(file.name);
    };


    const isHttps = window.location.protocol === "https:";
    const apiServers = {
        go8090: { name: "F42(Go:8090)", base: "http://192.168.3.11:5000", api: "/PT3/doLSapi7.php" },
        // fedora42: { name: "F42", base: "http://192.168.3.11:5000", api: "/PT3/doLSapi7.php" },
        // https 443 httpS://m_dai117.mydns.jp 対応 20251226
        fedora42: {
        name: "F42",
            base: isHttps
            // ? "https://m_dai117.mydns.jp"
            ? "http://192.168.3.11:5000"
            : "http://192.168.3.11:5000",
            api: "/PT3/doLSapi7.php",
            diffApi: "/PT3/doLSapi7diff.php",
        },
        pi42: { name: "pi42", base: "http://192.168.3.170", api: "/PT3/doLSapi5_pi42.php" },
    };

    const apiBase = apiServers[server].base;
    const apiPath = apiServers[server].api;
    // const diffApiPath = apiServers[server].diffApi;
    // diff API は常に PT3 にある
    // const diffApiBase = apiServers["PT3"].base;
    const diffApiBase = apiServers[server].base;

    const buildFilePath = (folder, fileName) => {
        if (folder.includes("/")) return `${apiBase}/${folder}/${fileName}`;
        if (folder === "imagez") return `${apiBase}/PT3/imagez/${fileName}`;
        return `${apiBase}/${folder}/${fileName}`;
    };

    // 直近最近検索ワードを取得する関数 20251215
    const fetchRecentWords = async () => {
        try {
            const res = await fetch(`${apiBase}/PT3/doLSapi7his.php`);
            if (!res.ok) return;
            const data = await res.json();
            console.log("recentWords API:", data);
            if (Array.isArray(data)) setRecentWords(data);

        } catch (e) {
            console.error("recent search fetch error", e);
        }
    };

    // --- トースト通知関数 ---
    const showToast = (msg) => {
        const toast = document.createElement("div");
        toast.textContent = msg;
        toast.style.position = "fixed";
        toast.style.bottom = "30px";
        toast.style.right = "30px";
        toast.style.padding = "10px 18px";
        toast.style.backgroundColor = "rgba(0,0,0,0.6)";
        toast.style.color = "white";
        toast.style.borderRadius = "6px";
        toast.style.fontSize = "13px";
        toast.style.fontWeight = "bold";
        toast.style.zIndex = "2000";
        toast.style.transition = "opacity 0.5s";
        toast.style.opacity = "1";
        document.body.appendChild(toast);

        setTimeout(() => { toast.style.opacity = "0"; }, 2000); // 2秒でフェードアウト
        setTimeout(() => { document.body.removeChild(toast); }, 2500); // 2.5秒後に削除
    };

    const handleOpenInNewTab = () => {
        const videoElement = document.querySelector("video");
        let currentTime = 0;
        if (videoElement) {
            currentTime = videoElement.currentTime;
            videoElement.pause();
        }
        const url2 = `${process.env.PUBLIC_URL}/mkv_player.html?src=${encodeURIComponent(selectedMedia)}&t=${Math.floor(currentTime)}`;
        window.open(url2, "_blank");
    };

    //* const handleSearch = async () => {
    //*   if (!query.trim()) { setError("検索ワードを入力してください"); return; }

    // ★変更：引数 q を追加（デフォルトは state の query）
    // 検索履歴ボタンから検索するときにそなえて引数q=queryを入れる 20251215
    const handleSearch = async (q = query) => {

        // ★ これをしておかないとq.trim is not a functionのようなエラーになってしまう
        // 文字列objectを期待しているのに、イベントオブジェクトが q に入ってきてるのが原因
        if (typeof q !== "string") {
            q = query;
        }
        if (!q.trim()) { setError("検索ワードを入力してください"); return; }

        let targetFolder = folder;

        // GAZ コマンド判定
        // if (query.toUpperCase() === "GAZ") {
        if (q.toUpperCase() === "GAZ") {
            targetFolder = "H2";
        }
        // } else if (query.toUpperCase() === "imagez") {
        //     targetFolder = "imagez";
        // }

        // URL に query を反映
        // setSearchParams({ query });
        //* CHDIRでディレクトリ移動PT6相当実装 20251230
        //* setSearchParams({ q });
        setSearchParams({
            q,
            d: targetFolder
        });

        setFiles([]);
        setLoading(true);
        setError(null);

        // CHDIR PT3やPT6の選択肢はここでurlに突っ込まれてget/postでなくfetchででdoLSapi7.phpに飛ばす
        // const url = `${apiBase}${apiPath}?query=${encodeURIComponent(query)}&folders=${folder}&page=${page}&per_page=${perPage}`;
        // const url = `${apiBase}${apiPath}?query=${encodeURIComponent(query)}&folders=${targetFolder}&page=${page}&per_page=${perPage}`;
        // const url = `${apiBase}${apiPath}?query=${encodeURIComponent(q)}&folders=${targetFolder}&page=${page}&per_page=${perPage}`;


        let url;

        //* if (useDiff) {
        //*     // 差分API（query / folder / page 不要）20260102
        //*     // url = `${apiBase}${apiServers[server].diffApi}?limit=${perPage}`;
        //*     // url = `${apiBase}${apiServers[server].diffApi}?limit=${perPage}`;
        //*     //url = `${apiBase}${diffApiPath}?query=${encodeURIComponent(q)}&limit=${perPage}`;
        //*     url = `${apiBase}${apiServers[server].diffApi}?query=${encodeURIComponent(q)}&limit=${perPage}`;
        //* } else {
        //*     // 従来API
        //*     url = `${apiBase}${apiPath}?query=${encodeURIComponent(q)}&folders=${targetFolder}&page=${page}&per_page=${perPage}`;
        //* }

        //* パラメータqほかを従来版検索（高速でない）と同じにする
        //*NG if (useDiff) {
        // [MODIFIED by ChatGPT diff-enhancement]
        // 差分高速モードでも従来APIと同じパラメータ体系を使う
        // url = `${apiBase}${apiServers[server].diffApi}`

if (useDiff) {
// diff API（PT3に集約されたロジック）
url = `${diffApiBase}${apiServers[server].diffApi}`
+ `?q=${encodeURIComponent(q)}`
// + `&folder=${encodeURIComponent(server)}`   // ← ★ここ重要
+ `&folder=${encodeURIComponent(folder)}`   // ← ★ここ重要
+ `&page=${page}`
+ `&per_page=${perPage}`;
} else {
// 従来API（そのまま）
url = `${apiBase}${apiPath}`
+ `?query=${encodeURIComponent(q)}`
+ `&folders=${targetFolder}`
+ `&page=${page}`
+ `&per_page=${perPage}`;
}

        //*NG url = `${diffApiBase}${apiServers[server].diffApi}`
        //*NG + `?q=${encodeURIComponent(q)}`
        //*NG + `&folders=${encodeURIComponent(targetFolder)}`
        //*NG + `&page=${page}`
        //*NG + `&per_page=${perPage}`;
        //*NG } else {
        //*NG // 従来API（そのまま）
        //*NG url = `${apiBase}${apiPath}?query=${encodeURIComponent(q)}&folders=${targetFolder}&page=${page}&per_page=${perPage}`;
        //*NG }

        try {
            // doLSapi7.phpにfetchして戻り値をresに入れる
            const res = await fetch(url);
            if (!res.ok) throw new Error(`APIエラーどえす: ${res.status}`);

            const data = await res.json();

// 差分diffのPT6対応
let files = [];
let total = 0;

if (useDiff) {
    // 差分API（doLSapi7diff.php）
    if (!data || !Array.isArray(data.files)) {
        throw new Error("不正なJSONレスポンス(diff)");
    }

    // ★★★ ここが重要：表示先（PT3 / PT6）を UI 側で注入
    files = data.files.map(f => ({
        // JavaScriptのスプレッド構文（spread syntax）
        // オブジェクトf が持っているプロパティを全部コピーする ...f
        ...f,
        folder: server,   // ← PT3 / PT6 を強制的に付与
    }));

    total = data.total ?? files.length;

} else {
    // 従来API（doLSapi7.php）
    if (!data || !Array.isArray(data.results)) {
        throw new Error("不正なJSONレスポンス(normal)");
    }
    files = data.results;
    total = data.total ?? 0;
}

setFiles(files);
setTotal(total);

            //NG let files = [];
            //NG let total = 0;
            //NG 
            //NG if (useDiff) {
            //NG     // 差分API
            //NG     if (!data || !Array.isArray(data.files)) {
            //NG     throw new Error("不正なJSONレスポンス(diff)");
            //NG     }
            //NG     files = data.files;
            //NG     total = data.total ?? data.files.length;
            //NG     } else {
            //NG     // 従来API
            //NG     if (!data || !Array.isArray(data.results)) {
            //NG     throw new Error("不正なJSONレスポンス(normal)");
            //NG     }
            //NG     files = data.results;
            //NG     total = data.total ?? 0;
            //NG }
            //NG 
            //NG setFiles(files);
            //NG setTotal(total);

            //* // if (!data || !Array.isArray(data.results)) throw new Error("不正なJSONレスポンス");
            //* // if (!data || !Array.isArray(data.files)) throw new Error("不正なJSONレスポンス");
            //* if (!data || !Array.isArray(data.files)) {
            //*         throw new Error("不正なJSONレスポンス");
            //* }
            //* setFiles(data.files);
            //* setTotal(data.total);
            //* // setFiles(data.results);

            setTotal(typeof data.total === "number" ? data.total : 0);

            // if (query.toUpperCase() === "GAZ") {
            if (q.toUpperCase() === "GAZ") {
                setFolder("H2"); // GAZボタン表示用にfolder更新
            }
            // } else if (query.toUpperCase() === "GAZ") {
                // setFolder("imagez"); // GAZボタン表示用にfolder更新
            // }
            //
            // 直近最新検索履歴 20251215
            await fetchRecentWords();

        } catch (err) {
            console.error(err);
            setError(err.message || "通信エラーが発生しました");
            setFiles([]);
            setTotal(0);
        } finally { setLoading(false); }
    };

// ★変更：検索履歴ボタン専用ハンドラ
const handleRecentClick = (word) => {
    setQuery(word);    // 検索欄に反映（見た目）
    setPage(1);        // ページを1に戻す
    handleSearch(word); // ★ 必ずこの単語で検索を走らせる
};



    // // 日付検索実装　20251202
    // const handleDateSearch = async() => {
    //     const q = query.trim();
    //     if (!/^\d+$/.test(q)) { showToast("数字のみ入力してください"); return; }
    //     let params = {};
    //     // 日付8桁ならYYYYMMDD
    //     if (q.lentgh === 8) {
    //         params.date = `${q.slice(0,4)}-${q.slice(4,6)}-${q.slice(6,8)}`;
    //     } else if (q.length === 4) {
    //         params.year = q;
    //     } else if (q.length === 1) {
    //         params.month = q;
    //     } else if (q.length === 2) {
    //         params.day = q;
    //     } else {
    //         showToast("日付形式が不正です");
    //         return;
    //     }
    //     const url = `${apiBase}${apiPath}?date_search=1&folders=${folder}` +
    //                 Object.entries(params).map(([k,v])=>`&${k}=${v}`).join("");

    //     setLoading(true);
    //     try {
    //         const res = await fetch(url);
    //         const data = await res.json();
    //         setFiles(data.results || []);
    //         setTotal(data.total || 0);
    //     } catch (err) {
    //         showToast("検索エラー");
    //     } finally { setLoading(false); }
    // };

    // 20260112
    useEffect(() => {
        if (recentOnly) {
            setPage(1);
        }
    }, [recentOnly]);

    useEffect(() => {
        const serverName = apiServers[server]?.name || server;
        const folderName = folder || "";
        const queryWord = query ? `/${query}` : "";
        document.title = `${serverName}/${folderName}${queryWord}`;
    }, [server, folder, query]);

    // ★ 初期表示時に最近検索ワードを取得（20251215）
    useEffect(() => {
            fetchRecentWords();
    }, []);

    //* CHDIRでディレクトリ移動PT6相当実装 20251230
    //* useEffect(() => { if (query) handleSearch(); }, [page]);
    //# pagingが起動しないデグレ
    //#     setPage(1);
    //#     handleSearch(query);
    //#     }
    //#     // eslint-disable-next-line react-hooks/exhaustive-deps
    //# }, []);
    useEffect(() => {
        if (!query) return;
        handleSearch(query);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    useEffect(() => {
        const handleKeyDown = (e) => { if (e.key === "Escape") setSelectedMedia(null); };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);
    //* 20251124
    //* ↓Cloudflareへのデプロイでコケるので
    //* ↓useEffect の依存配列に missing dependencies を追加する
    //*}, [apiServers]);

    // mp3player実装 20251207 日曜日
    //http://192.168.3.11:5000/L8/play?input_mp3=ここにファイル名.mp3　で再生するように
    // const handleThumbClick = (file) => {
    //     const ext = file.name.split(".").pop().toLowerCase();
    //     const fileUrl = buildFilePath(folder, encodeURIComponent(file.name));
    //     if (["mp4","mov","webm","f4v","m4v","ts","mkv"].includes(ext)) {
    //         setSelectedMedia(fileUrl);
    //         setMediaType("video");
    //         setSelectedMediaFile(folder + '/' + file.name);
    //     } else if (["jpg","jpeg","png","gif","svg"].includes(ext)) {
    //         setSelectedMedia(fileUrl); setMediaType("image");
    //     } else { window.open(fileUrl, "_blank"); }
    // };

    const handleThumbClick = (file) => {

        if (!file || !file.name) {
            console.warn("file.name が未定義です", file);
            return;
        }

        const ext = file.name.split(".").pop().toLowerCase();
        const fileUrl = buildFilePath(folder, encodeURIComponent(file.name));

        //* http://192.168.3.11:5000/L8/play?input_mp3=20200424_053411_facebook_reel_.mp3&input_mp3Folder=PT3

        // https 443 httpS://m_dai117.mydns.jp 対応 20251226
        const base = window.location.protocol === "https:"
            // ? "https://m_dai117.mydns.jp"
            ? "http://192.168.3.11:5000"
            : "http://192.168.3.11:5000";

        // --- MP3 クリック時: 再生APIに飛ぶ ---
        if (ext === "mp3") {
            // const playUrl = `http://192.168.3.11:5000/L8/play?input_mp3=${encodeURIComponent(file.name)}&input_mp3Folder=${folder}`;
            const playUrl = `${base}/L8/play?input_mp3=${encodeURIComponent(file.name)}&input_mp3Folder=${folder}`;
            window.open(playUrl, "_blank");
            return;
        }
        // if (ext === "mp3") {
        //     const playUrl = `http://192.168.3.11:5000/L8/play?input_mp3=${encodeURIComponent(folder + "/" + file.name)}`;
        //     window.open(playUrl, "_blank");
        //     return;
        // }

        if (["mp4","mov","webm","f4v","m4v","ts","mkv"].includes(ext)) {
            setSelectedMedia(fileUrl);
            setMediaType("video");
            setSelectedMediaFile(folder + '/' + file.name);
        // } else if (["jpg","jpeg","png","gif","svg"].includes(ext)) {
        } else if (["jpg","jpeg","png","gif","bmp","webp","svg"].includes(ext)) {
            // setSelectedMedia(fileUrl);
            // setMediaType("image");
            window.open(fileUrl, "_blank");
            return;
        } else {
            window.open(fileUrl, "_blank");
        }
    };

    // 20260112
    // const totalPages = Math.max(1, Math.ceil(total / perPage));
    // const displayedFiles = filterRecentVideos(files);
    //* const displayedFiles = recentOnly
    //*     ? filterRecentVideos(files)
    //*     : files;

    // 20260223
    const filterImages = (files) => {
        if (showJpg) return files;
        // checkboxオフ
        return files.filter(f => {
            if(!f.name) return files;
            // if(!f.name) return true;
            const ext = f.name.split(".").pop().toLowerCase();
            return !["jpg","jpeg","png","gif","bmp","webp","svg"].includes(ext);
        });
    }
    const displayedFiles = filterImages(
        recentOnly ? filterRecentVideos(files) : files
    );

    const totalPages = recentOnly
        ? Math.max(1, Math.ceil(displayedFiles.length / perPage))
        : Math.max(1, Math.ceil(total / perPage));

    const formatDate = (ts) => {
        const d = new Date(ts * 1000);
        const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        return `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")}(${days[d.getDay()]}) ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
    };
    const formatSize = (bytes) => {
        if (bytes >= 1024 ** 3) return (bytes / 1024 ** 3).toFixed(2) + " GB";
        if (bytes >= 1024 ** 2) return (bytes / 1024 ** 2).toFixed(2) + " MB";
        if (bytes >= 1024) return (bytes / 1024).toFixed(2) + " KB";
        return bytes + " B";
    };

    // const folderButtons = ["PT3","PT6","USB","USB_GOLDEN", "imagez","SV2_ALL"];
    const folderButtons = ["PT3","PT6","2TB","USB","USB_GOLDEN", "imagez","SV2_ALL"];
    if (query.toUpperCase() === "GAZ" || folder === "H2") {
        // folderButtons.push("imagez");
        folderButtons.push("GAZ");
    }

    // --- 音声抽出（トースト通知に変更） ---
    const handleExtractAudio = async () => {
        if (!selectedMediaFile) { showToast("動画を選択してください"); return; }
        const url = `${apiBase}/PT3/doLSapiAudio.php?file=${encodeURIComponent(selectedMediaFile)}`;
        console.log("doLSapiAudioのURL: " + url);
        try {
            await fetch(url); // PHP側でffmpegを非同期で実行
            const fileName = selectedMediaFile.split("/").pop();
            // showToast(`${fileName.replace(/\.[^/.]+$/, "_audio.mp3")} を作成中…`);
            showToast(`${fileName.replace(/\.[^/.]+$/, ".mp3")} を作成中…`);
        } catch(err) { showToast("通信エラー: " + err.message); }
    };

    return (
        <div className="container">
            {/* --- サーバ選択 --- */}
            <div style={{ marginBottom: "15px" }}>
                <label style={{ marginRight: "10px", fontWeight: "bold" }}>接続先サーバ：</label>
                <select value={server} onChange={(e)=>setServer(e.target.value)} style={{ padding: "6px 10px", borderRadius: "6px" }}>
                    {Object.entries(apiServers).map(([key,srv]) => (<option key={key} value={key}>{srv.name}</option>))}
                </select>
            </div>

            {/* --- 検索 --- */}
            <div style={{ marginBottom: "12px" }}>
                <input
                    type="text" value={query} onChange={(e)=>setQuery(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&handleSearch()}
                    placeholder="検索ワードを入力"
                    style={{ width: "100%", padding: "8px", fontSize: "1rem", borderRadius: "8px", border: "1px solid #ccc", marginBottom: "8px", boxSizing: "border-box" }}
                />
                <button onClick={handleSearch} style={{ width:"100%", padding:"10px", fontSize:"1.1rem", borderRadius:"8px", border:"none", backgroundColor:"#1976d2", color:"white", cursor:"pointer", fontWeight:"bold" }}>🔍 検索</button>

                <label style={{ display:"block", marginTop:"10px" }}>
                    <input
                        type="checkbox"
                        checked={useDiff}
                        onChange={(e)=>setUseDiff(e.target.checked)}
                        style={{ marginRight:"6px" }}
                    />
                    差分表示（高速）
                </label>

                {/*  直近N日以内フィルタ 20260112 */}
                <label style={{ display:"block", marginTop:"6px" }}>
                    <input
                        type="checkbox"
                        checked={recentOnly}
                        onChange={(e)=>setRecentOnly(e.target.checked)}
                        style={{ marginRight:"6px" }}
                    />
                    直近
                    <select
                        value={recentDays}
                        onChange={(e)=>setRecentDays(Number(e.target.value))}
                        style={{ margin:"0 6px" }}
                    >
                        <option value={3}>3日以内</option>
                        <option value={7}>7日以内</option>
                        <option value={31}>31日以内</option>
                        <option value={60}>60日以内</option>
                        <option value={90}>90日以内</option>
                        <option value={180}>180日以内</option>
                        <option value={360}>360日以内</option>
                    </select>
                    のみ
                </label>

                {/* 20260223 */}
                <label style={{ display:"block", marginTop:"6px" }}>
                    <input
                        type="checkbox"
                        checked={showJpg}
                        onChange={(e)=>setShowJpg(e.target.checked)}
                        style={{ marginRight:"6px" }}
                    />
                    jpg
                </label>

                {/* --- 日付検索ボタン 20251202 --- */}
                {/*
                <button
                    onClick={handleDateSearch}
                    style= {{
                        position:"absolute", right:"0px", bottom:"-40px",
                        padding:"6px 12px", fontSize:"0.8rem",
                        backgroundColor:"#2e7d32",  // #2e7d32 緑系
                        cursor:"pointer", fontWeight:"bold",
                        boxShadow:"0 2px 4px rgba(0,0,0,0.3)"
                    }}
                 >📅 日付検索</button>
                 */}
            </div>

            {/* --- フォルダボタン --- */}
            <div style={{ marginBottom:"20px" }}>
                {/* PT3/PT6/..mapから取り出してf に入れる */}
                {/* for i in map; do echo "$i";的な */}
                {/* 選択されたフォルダCHDIRは↑のhandleSearchで処理*/}
                {folderButtons.map(f=>(
                    // <button key={f} onClick={()=>{setFiles([]); setPage(1); setFolder(f);}}
                    <button
                        key={f}
                        // onClick={() => setFolder(f === "GAZ" ? "H2" : f)}
                        onClick={() => {
                            setFiles([]);     // 前回結果クリアrefleshリフレッシュ
                            setPage(1);       // ページを1ページ目に戻す
                            setFolder(f === "GAZ" ? "H2" : f);
                        }}
                        /* style={{marginRight:"10px", padding:"8px 16px", borderRadius:"8px", border:"none",
                            backgroundColor: folder===f?"#0d6efd":"#e0e0e0",
                            color: folder===f?"white":"black",
                            cursor:"pointer", fontWeight: folder===f?"bold":"normal",
                            boxShadow: folder===f?"0 0 6px rgba(0,0,0,0.3)":"none",
                            transition:"all 0.2s ease"
                        }} 
                        */
                        style={{
                            marginRight: "10px",
                            padding: "8px 16px",
                            borderRadius: "8px",
                            border: "none",
                            backgroundColor: (folder === f || (f==="GAZ" && folder==="H2")) ? "#0d6efd" : "#e0e0e0",
                            color: (folder === f || (f==="GAZ" && folder==="H2")) ? "white" : "black",
                            cursor: "pointer",
                            fontWeight: (folder === f || (f==="GAZ" && folder==="H2")) ? "bold" : "normal",
                            boxShadow: (folder === f || (f==="GAZ" && folder==="H2")) ? "0 0 6px rgba(0,0,0,0.3)" : "none",
                            transition: "all 0.2s ease"
                        }}
                    >{f}</button>
                ))}
            </div>

            {/* --- 最近の検索ワード 20251215 --- */}
            {recentWords.length > 0 && (
                <div style={{
                    marginTop: "10px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px"
                    }}>
                    {recentWords.map((word, i) => (
                        <button
                            key={i}

                            onClick={() => handleRecentClick(word)}

                            // onClick={() => {
                            //     setQuery(word);
                            //     setPage(1);
                            //     handleSearch();
                            // }}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "14px",
                                border: "1px solid #ccc",
                                background: "#f5f5f5",
                                cursor: "pointer",
                                fontSize: "0.85rem"
                            }}
                        >
                        {word}
                        </button>
                    ))}
                </div>
            )}

            {/* --- ファイル表示 --- */}
            {loading && <p>読み込み中...</p>}
            {error && <p style={{color:"red"}}>エラー: {error}</p>}

            {/* <div className="grid" style={{ display:"flex", flexWrap:"wrap", gap:"12px" }}>*/}
            {/* {files.length===0&&!loading && <p>該当ファイルはありません。</p>} */}
            {/* --- 20260112 --- */}
                <div className="grid" style={{ display:"flex", flexWrap:"wrap", gap:"12px" }}>
                {displayedFiles.length === 0 && !loading && (
                    <p>該当ファイルはありません。</p>
                )}

                {/* files.map(...) の直前で適用（ここ超重要）*/}
                {/* {files.map((file,i)=>( */}
                {/* {filterRecentVideos(files).map((file,i)=>( */}
                    {displayedFiles.map((file, i) => (
                    <div key={i} className="thumb-card" onClick={()=>handleThumbClick(file)}
                        style={{ cursor:"pointer", border:"1px solid #ccc", borderRadius:"12px", padding:"10px", width:"200px", textAlign:"center", background:"#fafafa", boxShadow:"0 2px 4px rgba(0,0,0,0.1)" }}>
                        {/* mp3アイコン実装 */}
                        {/*
                        // 画像サムネイル対応前↓ 20251210
                        // {file.thumb ? (
                        //     <img 
                        //         src={buildFilePath(folder,file.thumb)} 
                        //         alt={file.name} 
                        //         onError={(e)=>e.target.src=`${apiBase}/PT3/dummy.jpg`} 
                        //         style={{width:"100%", borderRadius:"8px"}} 
                        //     />
                        // ) : (() => {
                        //     const ext = file.name.split('.').pop().toLowerCase();
                        //     if(ext === "mp3") {
                        //         // return <img src={`${process.env.PUBLIC_URL}/icon_mp3.png`} alt="mp3" style={{width:"100%", borderRadius:"8px"}} />;

                        //         // return <img src={buildFilePath(folder, 'icon_mp3.png')} alt="mp3" style={{width:"100%", borderRadius:"8px"}} />;
                        //         return <img src={buildFilePath(folder, 'icon_golang.png')} alt="mp3" style={{width:"100%", borderRadius:"8px"}} />;
                        //     } else {
                        //         return <div style={{width:"100%", height:120, background:"#ddd"}} />;
                        //     }
                        // })()}
                        */}

                        {/* 🔥 画像サムネイル（改良済み） */}

                        {(() => {
                            const ext = file.name.split(".").pop().toLowerCase();
                            const fileUrl = buildFilePath(folder, encodeURIComponent(file.name));

                            // ★★★ 動画のサムネイル（file.thumb がある場合）
                            if (["mp4","mov","webm","mkv","ts","m4v","f4v"].includes(ext)) {
                                //*  ======================================================
                                //*  [ADD by ChatGPT] 差分高速モード用 動画サムネ補完
                                //*  diff API では file.thumb が無いが、
                                //*  Fedora42 運用では必ず
                                //*  /{folder}/thumb_movie_images/{動画名}_01.jpg
                                //*  が存在するため、ここで自動生成する
                                //*  ======================================================
                                let diffThumbPath = null;
                                if (
                                    useDiff &&
                                    !file.thumb &&
                                    file.name
                                ) {
                                    // ======================================================
                                    // [FIX by ChatGPT] PT3 / PT6 差分JSONでは file.folder が無い
                                    // UI state の folder を使ってサムネパスを補完する
                                    // ======================================================
                                    diffThumbPath =
                                        `${apiBase}/${folder}/thumb_movie_images/` +
                                        `${encodeURIComponent(file.name)}_01.jpg`;
                                }
                                //# if (
                                //#     useDiff &&
                                //#     !file.thumb &&
                                //#     file.folder &&
                                //#     file.name
                                //# ) {
                                //#     diffThumbPath =
                                //#         `${apiBase}/${file.folder}/thumb_movie_images/` +
                                //#         `${encodeURIComponent(file.name)}_01.jpg`;
                                //# }

                                //* if (file.thumb) {
                                //*     return (
                                //*         <img
                                //*             src={buildFilePath(folder, file.thumb)}

                                //# チカチカNG
                                //# if (file.thumb || diffThumbPath) {
                                //#     return (
                                //#         <img
                                //#             src={
                                //#                 file.thumb
                                //#                 ? buildFilePath(folder, file.thumb)
                                //#                 : diffThumbPath   // [ADD by ChatGPT]
                                //#             }
                                //#             alt={file.name}
                                //#             style={{
                                //#                 width: "100%",
                                //#                 height: "150px",
                                //#                 objectFit: "cover",
                                //#                 objectPosition: "center",
                                //#                 borderRadius: "8px",
                                //#                 background: "#ddd",
                                //#             }}
                                //#             onError={(e)=>{ e.target.src = `${apiBase}/PT3/dummy_video.jpg`; }}
                                //#         />
                                //#     );
                                //# }

                                if ((file.thumb || diffThumbPath) && !thumbFailed[file.name]) {
                                    const thumbSrc = file.thumb
                                        ? buildFilePath(folder, file.thumb)
                                        : diffThumbPath;

                                    return (
                                        <img
                                            src={thumbSrc}
                                            alt={file.name}
                                            style={{
                                                width: "100%",
                                                height: "150px",
                                                objectFit: "cover",
                                                objectPosition: "center",
                                                borderRadius: "8px",
                                                background: "#ddd",
                                            }}
                                            loading="lazy"
                                            onError={() => {
                                                setThumbFailed(prev => ({
                                                    ...prev,
                                                [file.name]: true
                                            }));
                                        }}
                                        />
                                    );
                                }


                                // thumb が無い動画はアイコンに fallback
                                return (
                                    <img
                                        // src={`${apiBase}/PT3/video_icon.png`}
                                        // alt="video"
                                        // style={{
                                        // width: "100%",
                                        // height: "150px",
                                        // objectFit: "contain",
                                        // borderRadius: "8px",
                                        // background: "#ddd",
                                        // }}
                                        // {/* src={buildFilePath(folder, "icon_golang.png")} */}
                                        src={buildFilePath(folder, "dummy.jpg")}
                                        alt="mp4"
                                        style={{ width: "100%", borderRadius: "8px" }}
                                    />
                                );
                            }

                            if (["jpg","jpeg","png","gif","bmp","webp","svg"].includes(ext)) {
                                return (
                                    <img
                                        src={fileUrl}
                                        alt={file.name}
                                        style={{
                                        width: "100%",
                                        height: "150px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        background: "#ddd"
                                    }}
                                    onError={(e)=>{ e.target.src = `${apiBase}/PT3/dummy.jpg`; }}
                                    />
                                );
                            }

                            if (ext === "mp3") {
                                return (
                                    <img
                                    // {/* src={buildFilePath(folder, "icon_golang.png")} */}
                                    src={buildFilePath(folder, "icon_mp3.svg")}
                                    alt="mp3"
                                    style={{ width: "100%", borderRadius: "8px" }}
                                    />
                                );
                            }

                            if (ext === "pdf") {
                                const base = file.name.replace(/\.pdf$/i, "");
                                const jpgThumb = buildFilePath(folder, encodeURIComponent(base + ".jpg"));

                                return (
                                    <img
                                        src={jpgThumb}
                                        alt={file.name}
                                        style={{
                                        width: "100%",
                                        height: "150px",
                                        objectFit: "cover", // 枠に合わせて拡大
                                        objectPosition: "center", // ★ 中央部分を表示
                                        borderRadius: "8px",
                                        background: "#ddd"
                                    }}
                                    onError={(e)=>{ 
                                        // JPG が無かった場合は PDF 用アイコンに fallback
                                        e.target.src = `${apiBase}/PT3/icon_PDF.svg`;
                                    }}
                                    />
                                );
                            }

                            return (
                                <div style={{
                                    width: "100%",
                                    height: "150px",
                                    background: "#ddd",
                                    borderRadius: "8px"
                                }} />
                            );
                        })()}

                        {/* 一覧タイトルクリックでクリップボードにコピーCOPY実装 20251228 */}
                        <p
                            onClick={(e) => {
                                e.stopPropagation();
                                handleTitleClick(file);
                            }}
                            onDoubleClick={(e) => {
                                e.stopPropagation();
                                handleTitleDoubleClick(file);
                            }}
                            title="クリック：再生 / ダブルクリック：コピー"
                            style={{
                                wordBreak: "break-all",
                                marginTop: 8,
                                cursor: "pointer",
                                color: "#1976d2",
                                /* fontWeight: "bold", */
                                userSelect: "none"
                            }}
                        >
                            {file.name}
                        </p>

                        <p style={{ color:"#666", fontSize:12 }}>{formatSize(file.size)}<br/>{formatDate(file.mtime)}</p>
                    </div>
                ))}
            </div>

            {/* --- ページネーション（改良版） --- */}
            <div className="pagination"
                 style={{
                    marginTop: "25px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap"
                 }}>
                <button
                    onClick={() => setPage(p => Math.max(1, p - 1))}
                    disabled={page === 1}
                    style={{
                        padding: "8px 14px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: page === 1 ? "#ccc" : "#1976d2",
                        color: "white",
                        cursor: page === 1 ? "not-allowed" : "pointer",
                        transition: "background 0.3s",
                    }}>
                    ← 前へ
                </button>

                <div style={{
                    background: "rgba(0,0,0,0.05)",
                    padding: "8px 16px",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <span style={{ fontWeight: "bold", color: "#333" }}>
                        {page} / {totalPages}
                    </span>
                    <input
                        type="number"
                        min="1"
                        max={totalPages}
                        placeholder="ページ番号"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                const num = parseInt(e.target.value);
                                if (!isNaN(num) && num >= 1 && num <= totalPages) {
                                    setPage(num);
                                    e.target.value = "";
                                }
                            }
                        }}
                        style={{
                            width: "80px",
                            padding: "6px 8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            fontSize: "0.9rem",
                            textAlign: "center",
                        }}
                    />
                    <button
                        onClick={() => {
                            const input = document.querySelector(".pagination input");
                            const num = parseInt(input.value);
                            if (!isNaN(num) && num >= 1 && num <= totalPages) {
                                setPage(num);
                                input.value = "";
                            }
                        }}
                        style={{
                            background: "#0d6efd",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            cursor: "pointer",
                            fontWeight: "bold",
                            transition: "background 0.3s",
                        }}>
                        Go
                    </button>
                </div>

                <button
                    onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                    disabled={page >= totalPages}
                    style={{
                        padding: "8px 14px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: page >= totalPages ? "#ccc" : "#1976d2",
                        color: "white",
                        cursor: page >= totalPages ? "not-allowed" : "pointer",
                        transition: "background 0.3s",
                    }}>
                    次へ →
                </button>
            </div>

            {/* --- ページネーション --- */}
{/*            <div className="pagination" style={{ marginTop:"20px" }}>
                <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}>← 前へ</button>
                <span style={{margin:"0 8px"}}>{page} / {totalPages}</span>
                <button onClick={()=>setPage(p=>Math.min(totalPages,p+1))} disabled={page>=totalPages}>次へ →</button>
            </div>
*/}

            {/* --- ポップアップ動画・画像 --- */}
            {selectedMedia && (
                <div style={{position:"fixed", top:0,left:0,width:"100%",height:"100%", backgroundColor:"rgba(0,0,0,0.7)", display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000}}
                     onClick={()=>setSelectedMedia(null)}>
                    <div style={{position:"relative", backgroundColor:"#000", padding:"20px", borderRadius:"12px"}} onClick={(e)=>e.stopPropagation()}>
                        {mediaType==="video" && <>
                            <video src={selectedMedia} controls autoPlay style={{width:"80vw", maxHeight:"80vh"}} />
                            <div style={{position:"absolute", bottom:"10px", right:"10px", display:"flex", gap:"15px"}}>
                                <button onClick={handleOpenInNewTab} style={{background:"none", color:"rgba(255,255,255,0.7)", border:"none", fontSize:"14px", cursor:"pointer", padding:"4px 8px"}}>別ウィンドウで開く</button>
                                <button onClick={handleExtractAudio} style={{background:"none", color:"rgba(255,255,255,0.7)", border:"none", fontSize:"14px", cursor:"pointer", padding:"4px 8px"}}>🎵 音声抽出</button>
                                <button onClick={()=>setSelectedMedia(null)} style={{background:"none", color:"rgba(255,255,255,0.7)", border:"none", fontSize:"14px", cursor:"pointer", padding:"4px 8px"}}>閉じる</button>
                            </div>
                        </>}
                        {mediaType==="image" && <>
                            <img src={selectedMedia} alt="selected" style={{width:"80vw", maxHeight:"80vh"}} />
                            <div style={{position:"absolute", bottom:"10px", right:"10px"}}>
                                <button onClick={()=>setSelectedMedia(null)} style={{background:"none", color:"rgba(255,255,255,0.7)", border:"none", fontSize:"14px", cursor:"pointer", padding:"4px 8px"}}>閉じる</button>
                            </div>
                        </>}
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;

